import { isColumnPercentage } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputTableColumnModel } from '@blaze-shared/elements-domain';
import { type BlazeSchema, type DatasetRow, isGroupByRow } from '@blaze-shared/schema-domain';
import { isNullish } from '@blaze-shared/shared-util';

export function computeColumnExtremes(
  columns: PropertiesConfigInputTableColumnModel[] | undefined,
  rows: DatasetRow[] | undefined,
  schema: BlazeSchema | undefined,
  resolveColumnName: (c: PropertiesConfigInputTableColumnModel) => string | undefined,
): Record<string, { min: number; max: number }> {
  if (!columns?.length || !rows?.length) {
    return {};
  }

  const extremes: Record<string, { min: number; max: number }> = {};

  for (const column of columns) {
    if (column.format !== 'progressBar') {
      continue;
    }
    let { min, max } = column.progressBar ?? {};

    if (isNullish(min) || isNullish(max)) {
      const columnName = resolveColumnName(column);
      if (!columnName) {
        continue;
      }
      if (isColumnPercentage(column.name, schema)) {
        min ??= 0;
        max ??= 100;
      } else {
        const numericValues = rows
          .filter((row) => !isGroupByRow(row))
          .map((row) => Number(row[columnName]))
          .filter((v) => Number.isFinite(v));

        if (!numericValues.length) {
          continue;
        }

        min ??= Math.min(...numericValues);
        max ??= Math.max(...numericValues);
      }
    }

    extremes[column.name] = { min, max };
  }
  return extremes;
}
